'use client';

import { Trans } from '@lingui/react/macro';
import { useLocalizedLinks } from '@/components/core/hooks';
import InternalLink from '../internal-link';
import * as styles from './not-found.styles';
import { Button, Element } from '../../atoms';
import ErrorPage from '../error-page';

const NotFound = () => {
  const links = useLocalizedLinks();

  return (
    <ErrorPage background="404">
      <Element className={styles.title} as="h1" typography="title">
        <span>😭</span>
        <span>
          <Trans>Error 404</Trans>
        </span>
        <span>
          <Trans>Oops! We couldn&apos;t find the page you&apos;re looking for.</Trans>
        </span>
      </Element>
      <p>
        <Trans>
          It seems the content you&apos;re searching for is either no longer available or the page may have been removed. You can try searching again
          or head back to the homepage to continue browsing.
        </Trans>
      </p>
      <Button as={InternalLink} variant="primary" href={links.root()}>
        <Trans>Return Home</Trans>
      </Button>
    </ErrorPage>
  );
};

export default NotFound;
